import { motion } from "framer-motion";

const R = 36;
const DX = R * 1.5;
const DY = R * Math.sqrt(3);

const hexPoints = (cx, cy) =>
  Array.from({ length: 6 }, (_, i) => {
    const a = (Math.PI / 3) * i;
    return `${(cx + R * Math.cos(a)).toFixed(1)},${(cy + R * Math.sin(a)).toFixed(1)}`;
  }).join(" ");

const SITES = ["2,2", "4,4", "1,4", "5,2", "3,5", "4,1"];

export const ZeoliteCage = () => {
  const cells = [];
  for (let c = 0; c < 7; c++) {
    for (let r = 0; r < 9; r++) {
      cells.push({ key: `${c},${r}`, cx: c * DX + R, cy: r * DY + (c % 2 ? DY / 2 : 0) + R });
    }
  }
  return (
    <div className="border border-line bg-obsidian p-2" data-testid="hero-zeolite-graphic">
      <div className="overflow-hidden aspect-[4/5]">
        <motion.svg
          viewBox="-8 -8 412 640"
          className="w-full h-full"
          preserveAspectRatio="xMidYMid slice"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.2, delay: 0.5 }}
          role="img"
          aria-label="Schematic of geometric encapsulation of theobromine"
        >
          <motion.g
            animate={{ y: [0, -10, 0] }}
            transition={{ duration: 9, repeat: Infinity, ease: "easeInOut" }}
          >
            {cells.map((cell) => (
              <polygon
                key={cell.key}
                points={hexPoints(cell.cx, cell.cy)}
                fill="none"
                stroke={SITES.includes(cell.key) ? "#3FA98C" : "rgba(255,255,255,0.16)"}
                strokeWidth={SITES.includes(cell.key) ? 1.4 : 1}
              />
            ))}
            {cells
              .filter((c) => SITES.includes(c.key))
              .map((cell, i) => (
                <motion.circle
                  key={cell.key}
                  cx={cell.cx}
                  cy={cell.cy}
                  r={4}
                  fill="#3FA98C"
                  animate={{ opacity: [0.35, 1, 0.35] }}
                  transition={{ duration: 2.6, repeat: Infinity, delay: i * 0.4 }}
                />
              ))}
          </motion.g>
        </motion.svg>
      </div>
      <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/45 px-1 py-2.5 flex justify-between">
        <span>Fig. 01 · Geometric encapsulation of theobromine</span>
        <span>Schematic</span>
      </p>
    </div>
  );
};
